import { createSelector } from 'reselect'

/** A Redux selector to retrieve channel updating details
 * @param state - The Redux state
 * @param {Object} {} - The channel update detail to fetch
 */

const getChannelUpdateInfo = (state: any) => state && state.channel && state.channel.update ? state.channel.update : undefined

/** A Redux selector to retrieve channel in progress state
 * @param state - The Redux state
 * @param {Boolean} - Indicates channel update in progress.
 */

export const selectUpdateInProgress = createSelector(
  getChannelUpdateInfo,
  (data) => data ? data.inProgress : undefined
)

/** A Redux selector to retrieve channel update status
 * @param state - The Redux state
 * @param {String} - Indicates channel update status.
 */

export const selectChannelUpdateStatus = createSelector(
    getChannelUpdateInfo,
  (data) => data ? data.status : undefined
)
